import { useMemo } from 'react';
import JWTService from 'src/features/auth/data/service/jwtService';
import { DecodedJWTUser } from 'src/types/common';

const jwtService = new JWTService();

export const useDecodeJWT = (token: string | null) => {
  const decodedUser = useMemo(() => {
    if (!token) return null;
    try {
      return jwtService.decodeToken<DecodedJWTUser>(token);
    } catch (error) {
      console.error('Failed to decode JWT:', error);
      return null;
    }
  }, [token]);

  return {
    decodedUser,
    token,
  };
};
